import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

interface LiItemProps {
  children: React.ReactNode;
  step: number;
}

export const LiItem: React.FC<LiItemProps> = ({ step, children }) => {
  return (
    <LiRow>
      <Typography>
        <StrictLocalMsg
          defaultMessage="{stepNumber}."
          values={{ stepNumber: step }}
          description={{
            text: "Use to represent step number, for example: 1.,2.,3., etc.",
          }}
        />
      </Typography>
      <Spacer width="1x" />
      <Column>{children}</Column>
    </LiRow>
  );
};

const LiRow = styled.li`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;
